import React from 'react'

export default function ContactOnbizalomContent() {
  return (
    <>
      {/* Content will be added here */}
    </>
  )
}

